import React, { Component } from 'react';
import { supportsUserTimingApi } from 'utils/timing';
import {
  componentRenderStartMarkName,
  componentRenderEndMarkName,
  componentRenderMeasureName,
} from 'utils/timingNames';

// A higher-order component we can use to wrap components and record render
// time mesasurements using the standard User Timing API.
export default function withTiming(WrappedComponent, componentName) {
  /* global COLLECT_TIMING_REPORTS */
  if (COLLECT_TIMING_REPORTS && supportsUserTimingApi()) {
    const measure = componentRenderMeasureName(componentName);

    return class TimedComponent extends Component {
      constructor(props) {
        super(props);

        const { _timingKey: timingKey } = props;

        this.startMark = componentRenderStartMarkName(componentName, timingKey);
        this.endMark = componentRenderEndMarkName(componentName, timingKey);
        window.performance.mark(this.startMark);
      }

      componentDidMount() {
        window.performance.mark(this.endMark);
        window.performance.measure(measure, this.startMark, this.endMark);
        window.performance.clearMarks(this.startMark);
        window.performance.clearMarks(this.endMark);
      }

      shouldComponentUpdate() {
        window.performance.mark(this.startMark);
        return true;
      }

      componentDidUpdate() {
        window.performance.mark(this.endMark);
        window.performance.measure(measure, this.startMark, this.endMark);
        window.performance.clearMarks(this.startMark);
        window.performance.clearMarks(this.endMark);
      }

      render() {
        return <WrappedComponent {...this.props} />;
      }
    };
  }
  return WrappedComponent;
}
